<template>
  <div class="recharge_wrap">

    <div class="red_top_bg">
      <div class="back_left" @click="$router.go(-1)"></div>
      <div class="big_tit">{{ $t('Bank') }}</div>
    </div>

    <div class="wrap_box warp1" style="background:none;">
      <div class="item">
        <div class="ari_font">{{ $t('Bank') }}</div>
        <input class="card" type="text" value="Nequi" readonly disabled style="color:red;font-weight:700;" >
      </div>
      <div class="item">
        <div class="ari_font">{{ $t('Account Number') }}</div>
        <input class="card" type="text" v-model="bank.number" :placeholder="$t('account.fill_bank_number')">
      </div>
      <div class="item">
        <div class="ari_font">{{ $t('Full Name') }}</div>
        <input class="card" type="text" v-model="bank.user" :placeholder="$t('account.fill_bank_user')">
      </div>
      <!-- <div class="item">
        <div class="ari_font">{{ $t('account.IFSC') }}</div>
        <input class="card" type="text" v-model="bank.ifsc" :placeholder="$t('account.fill_IFSC')">
      </div> -->
    </div>
    <div class="basic_btn" @click="submitBtn">{{ $t('account.submit') }}</div>
  </div>

</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import {
  Overlay, Uploader, Button, DropdownMenu, DropdownItem, Toast
} from 'vant';

Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
export default {
  name: "addcountUsdt",
  data() {
    return {
      bank: {
        name: 'Bank',
        number: '',
        user: '',
        ifsc: "",
      },

    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {

    },
    submitBtn() {


      this.bank.name = this.Trim(this.bank.name,"g");
      this.bank.number = this.Trim(this.bank.number,"g");
      this.bank.user = this.Trim(this.bank.user,"g");
      this.bank.ifsc = this.Trim(this.bank.ifsc,"g");
      console.log(this.bank);
      if (!this.bank.name) {
        this.$notify(this.$t('account.fill_bank_name'));
        return;
      }

      if (!this.bank.number) {
        this.$notify(this.$t('account.fill_bank_number'));
        return;
      }
      if (!this.bank.user) {
        this.$notify(this.$t('account.fill_bank_user'));
        return;
      }
      // if (!this.bank.ifsc) {
      //   this.$notify(this.$t('account.fill_IFSC'));
      //   return;
      // }

      //check ifsc
      // let reg = /([A-Za-z0]{4})(0\d{6})$/g;
    //  let reg = /^[A-Za-z]{4}0[A-Z0-9]{6}$/g;
      //regex = /^[A-Z]{4}0[A-Z0-9]{6}$/g;
      // if (!reg.test(this.bank.ifsc)) {
      //   this.$notify(this.$t('account.fill_IFSC'));
      //   return;
      // }

      Fetch('/user/bank_add', {
        ...this.bank
      }).then(r => {

        if (r.code == 1) {
          // this.$router.replace("/withdrawRecord");
          this.$router.go(-1);
        }

      })
    },
    Trim(str, is_global) {
      let result;
      result = String(str).replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    }


  }
};
</script>

<style lang="less" scoped>
/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}


/deep/ .van-button--primary {
  background-color: transparent;
  border: none;
  width: 100%;
  height: 100%;
}

/deep/ .van-uploader__input-wrapper {
  width: 100%;
}

/deep/ .van-uploader__wrapper {
  width: 100%;
  height: 100%;
}

/deep/ .van-uploader__upload {
  width: 100%;
  height: 100%;
  margin: 0;
}

/deep/ .van-uploader__preview {
  margin: 0;
}

/deep/ .van-uploader__preview-image {
  width: 100%;
  height: 100%;
}

.back_left {
  background: url(../../views/images/item/back.png) no-repeat center center;
  background-size: 50% 50%;
  float: left;
}

.big_tit {
  color: #ffffff;
  float: left;
  height: 100%;
  line-height: 44px;
  width: 80%;
  text-align: center;
  font-size: 0.5rem;
}

.rela {
  position: relative;
  z-index: 11;
}

.warp1 {

  box-sizing: border-box;
  width: 96%;
  margin: 12px auto;

  .item {
    height: 50px;
    background-color: #ffffff;
    padding: 0 16px;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 10px;
    border-radius: 5px;

    &:last-child {
      border-bottom: none;
    }

    .card {
      width: 100%;
      text-indent: 10px;
    }

    input {
      line-height: 14px;
    }
  }
}

.ari_font {
  word-break: keep-all;
  white-space: nowrap;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, .8);
  line-height: 20px;
}

.basic_btn {
  margin: 35px auto 0 auto;
  background:linear-gradient(#fbe4cb, #e7bb90);
  color: #512E20;
  font-weight: 700;
}

.qrcode {
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;

  div {
    color: #999;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .upload {
    width: 100%;
    height: 100%;
  }

  .qrcode_img {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    background: linear-gradient(to left, #999, #999) left top no-repeat,
    linear-gradient(to bottom, #999, #999) left top no-repeat,
    linear-gradient(to left, #999, #999) right top no-repeat,
    linear-gradient(to bottom, #999, #999) right top no-repeat,
    linear-gradient(to left, #999, #999) left bottom no-repeat,
    linear-gradient(to bottom, #999, #999) left bottom no-repeat,
    linear-gradient(to left, #999, #999) right bottom no-repeat,
    linear-gradient(to left, #999, #999) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;

    span {
      line-height: 220px;
    }

    img {
      width: 240px;
      height: 240px;
      position: relative;
      top: -255px;
    }
  }
}
</style>
